import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { get, filter } from 'lodash'

import Dialog from '../dialog/Dialog'

import OrderRow from './OrderRow'
import styles from './List.module.scss'

const OrdersList = ({ onSelectOrder, orders, selectedOrderId, safIsUploading, offlineCardIds, offlineLocalIds, className }) => {
  const [showSAFComplete, setShowSAFComplete] = useState(false)
  const [showSyncingInProgress, setShowSyncingInProgress] = useState(false)
  const classNames = cn(styles.ordersList, className)

  const syncingInProgressMessage = "Orders are currently being synced. Please stop the sync to view orders."

  const maybeOnSelectOrder = (orderId) => {
    if (safIsUploading) {
      setShowSyncingInProgress(true)
      return
    }

    onSelectOrder(orderId)
  }

  return (
    <div className={classNames}>
      <div className={styles.headerRow}>
        <div>Tender</div>
        <div>Amount</div>
        <div>Order Number</div>
        <div>Created</div>
        <div>Status</div>     
        <div></div>
      </div>
      <div className={styles.scrollable}>
        {filter(orders, (order) => !!order?.orderNumber).map((order) => {
          return (
            <OrderRow
              isSelected={order.uuid === selectedOrderId}
              order={order}
              className={styles.row}
              key={order.uuid}
              onSelect={maybeOnSelectOrder}
              refundable={order.refundable}
            />
          )
        })}
      </div>
      {showSyncingInProgress && (
        <Dialog message={syncingInProgressMessage}>
            <div className={styles.actionsContainer}>
              <button className={styles.buttonContinue} onClick={() => setShowSyncingInProgress(false)}>OK</button>
            </div>
        </Dialog>
      )}
    </div>
  )
}

OrdersList.defaultProps = {
  orders: [],
}

OrdersList.propTypes = {
  onSelectOrder: PropTypes.func,
  orders: PropTypes.array,
  selectedOrderId: PropTypes.string,
}

export default OrdersList
